import { Observable, throwError as observableThrowError } from "rxjs"

import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { catchError } from "rxjs/operators"
import { LmApiService } from "./lm-api.service"

@Injectable()
export class UserProfileService {
    public readonly apiUrl = "/api/v2/user_profile/"

    constructor(private http: HttpClient, private lmApi: LmApiService) {}

    public getUserProfile(): Observable<any> {
        return this.lmApi.get(this.apiUrl).pipe(catchError((error) => observableThrowError(error)))
    }

    public updateUserProfile(userProfile: any, headers: any): Observable<any> {
        return this.lmApi
            .put(this.apiUrl, userProfile, headers)
            .pipe(catchError((error) => observableThrowError(error)))
    }

    public getAvailableSchools(zipCode: string): Observable<any> {
        const schoolsApiUrl = "/profile/school_search/?postal_code=" + zipCode

        return this.lmApi
            .get(schoolsApiUrl)
            .pipe(catchError((error) => observableThrowError(error)))
    }

    public postNewSchool(payload: any, headers: any): Observable<any> {
        const apiUrl = "/profile/school_suggestion/"

        return this.lmApi
            .post(apiUrl, payload, headers)
            .pipe(catchError((error) => observableThrowError(error)))
    }

    public getTeacherRoles(): any[] {
        const roles: any[] = [
            {
                id: 1,
                value: "Early Childhood Educator",
            },
            {
                id: 2,
                value: "K-12/Post-Secondary Educator",
            },
            {
                id: 3,
                value: "Administrator/Media Specialist",
            },
            {
                id: 4,
                value: "Homeschooler",
            },
            {
                id: 5,
                value: "Informal Educator",
            },
            {
                id: 6,
                value: "Learner",
            },
            {
                id: 9,
                value: "Other",
            },
            {
                id: null,
                value: "No role selected",
            },
        ]

        return roles
    }

    public getGrades(): string[] {
        const grades: string[] = [
            "PreK",
            "K",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
        ]

        return grades
    }

    public getSubjects(): any[] {
        const subjects: any[] = [
            {
                label: "Science",
                id: 8337,
            },
            {
                label: "Social Studies",
                id: 3026,
            },
            {
                label: "Math",
                id: 1184,
            },
            {
                label: "English Language Arts",
                id: 1880,
            },
            {
                label: "Engineering & Technology",
                id: 8353,
            },
            {
                label: "Health & Physical Education",
                id: 2806,
            },
            {
                label: "Preschool",
                id: 2949,
            },
            {
                label: "The Arts",
                id: 2663,
            },
            {
                label: "World Languages",
                id: 6267,
            },
            {
                label: "Professional Development",
                id: 6708,
            },
        ]

        return subjects
    }

    public getStates(): any[] {
        const states: any[] = [
            {
                name: "Alabama",
                abbreviation: "AL",
            },
            {
                name: "Alaska",
                abbreviation: "AK",
            },
            {
                name: "American Samoa",
                abbreviation: "AS",
            },
            {
                name: "Arizona",
                abbreviation: "AZ",
            },
            {
                name: "Arkansas",
                abbreviation: "AR",
            },
            {
                name: "California",
                abbreviation: "CA",
            },
            {
                name: "Colorado",
                abbreviation: "CO",
            },
            {
                name: "Connecticut",
                abbreviation: "CT",
            },
            {
                name: "Delaware",
                abbreviation: "DE",
            },
            {
                name: "District Of Columbia",
                abbreviation: "DC",
            },
            {
                name: "Federated States Of Micronesia",
                abbreviation: "FM",
            },
            {
                name: "Florida",
                abbreviation: "FL",
            },
            {
                name: "Georgia",
                abbreviation: "GA",
            },
            {
                name: "Guam",
                abbreviation: "GU",
            },
            {
                name: "Hawaii",
                abbreviation: "HI",
            },
            {
                name: "Idaho",
                abbreviation: "ID",
            },
            {
                name: "Illinois",
                abbreviation: "IL",
            },
            {
                name: "Indiana",
                abbreviation: "IN",
            },
            {
                name: "Iowa",
                abbreviation: "IA",
            },
            {
                name: "Kansas",
                abbreviation: "KS",
            },
            {
                name: "Kentucky",
                abbreviation: "KY",
            },
            {
                name: "Louisiana",
                abbreviation: "LA",
            },
            {
                name: "Maine",
                abbreviation: "ME",
            },
            {
                name: "Marshall Islands",
                abbreviation: "MH",
            },
            {
                name: "Maryland",
                abbreviation: "MD",
            },
            {
                name: "Massachusetts",
                abbreviation: "MA",
            },
            {
                name: "Michigan",
                abbreviation: "MI",
            },
            {
                name: "Minnesota",
                abbreviation: "MN",
            },
            {
                name: "Mississippi",
                abbreviation: "MS",
            },
            {
                name: "Missouri",
                abbreviation: "MO",
            },
            {
                name: "Montana",
                abbreviation: "MT",
            },
            {
                name: "Nebraska",
                abbreviation: "NE",
            },
            {
                name: "Nevada",
                abbreviation: "NV",
            },
            {
                name: "New Hampshire",
                abbreviation: "NH",
            },
            {
                name: "New Jersey",
                abbreviation: "NJ",
            },
            {
                name: "New Mexico",
                abbreviation: "NM",
            },
            {
                name: "New York",
                abbreviation: "NY",
            },
            {
                name: "North Carolina",
                abbreviation: "NC",
            },
            {
                name: "North Dakota",
                abbreviation: "ND",
            },
            {
                name: "Northern Mariana Islands",
                abbreviation: "MP",
            },
            {
                name: "Ohio",
                abbreviation: "OH",
            },
            {
                name: "Oklahoma",
                abbreviation: "OK",
            },
            {
                name: "Oregon",
                abbreviation: "OR",
            },
            {
                name: "Palau",
                abbreviation: "PW",
            },
            {
                name: "Pennsylvania",
                abbreviation: "PA",
            },
            {
                name: "Puerto Rico",
                abbreviation: "PR",
            },
            {
                name: "Rhode Island",
                abbreviation: "RI",
            },
            {
                name: "South Carolina",
                abbreviation: "SC",
            },
            {
                name: "South Dakota",
                abbreviation: "SD",
            },
            {
                name: "Tennessee",
                abbreviation: "TN",
            },
            {
                name: "Texas",
                abbreviation: "TX",
            },
            {
                name: "Utah",
                abbreviation: "UT",
            },
            {
                name: "Vermont",
                abbreviation: "VT",
            },
            {
                name: "Virgin Islands",
                abbreviation: "VI",
            },
            {
                name: "Virginia",
                abbreviation: "VA",
            },
            {
                name: "Washington",
                abbreviation: "WA",
            },
            {
                name: "West Virginia",
                abbreviation: "WV",
            },
            {
                name: "Wisconsin",
                abbreviation: "WI",
            },
            {
                name: "Wyoming",
                abbreviation: "WY",
            },
            {
                name: "No state selected",
                abbreviation: null,
            },
        ]

        return states
    }
}
